// css
import style from "css/room.module.css";
import React, { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import List from "components/mobile/meeting/room/List";
import Search from "components/mobile/meeting/room/Search";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * 파일명: room.js
 * 작성자: 권도훈
 * 작성일자: 25.02.24
 * 설명: 모바일 페이지 회의실 현황
 */
function Room() {
  // redux
  const payload = useSelector((state) => state.user);
  //searchParam
  const [searchParams, setSearchParams] = useSearchParams();
  //status
  const [room, setRoom] = useState({});

  //navigate
  const navigate = useNavigate();

  const [init, setInit] = useState(true);
  const [isRoomSearch, setIsRoomSearch] = useState(false);
  const [isScheduleSearch, setIsScheduleSearch] = useState(false);
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(dayjs(new Date()));
  const [roomList, setRoomList] = useState([]);
  const [scheduleList, setScheduleList] = useState([]);
  const [location, setLocation] = useState({
    id: "",
    label: "",
  });

  const setFixture = useCallback((fixture) => {
    const result = [];

    if (fixture.length > 0) {
      fixture.forEach((item) => {
        result.push({
          name: item.FIXTURES_NM,
          description: item.DESCRIPTION,
        });
      });
    }

    return result;
  }, []);

  const getRoomList = useCallback(() => {
    setLoading(true);

    const config = {
      params: {
        DEPT_CD: location.id,
      },
    };

    axios
      .get("/schedule/endpoint", config)
      .then((res) => {
        const resList = res.data.ENDPOINT;
        const list = [];
        resList.forEach((room) => {
          list.push({
            ENDPOINT_TYPE: room.ENDPOINT_TYPE,
            id: room.ENDPOINT_ID,
            title: room.ENDPOINT_NM,
            dept_code: room.DEPT_CD,
            time: {
              open: room.OPENTIME,
              close: room.CLOSETIME,
            },
            fixture: setFixture(room.FIXTURE),
            img: room.FILE_URL,
            capacity: room.CAPACITY,
            location: room.DEPT_NM_PARENT.split(","),
            endpoint: {
              name: room.ENDPOINT_NM,
            },
          });
        });
        setRoomList(list);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [location.id, setFixture]);

  const getScheduleList = useCallback(() => {
    setLoading(true);

    const config = {
      params: {
        ACTIVE_START: date.format("YYYY-MM-DD") + "T00:00:00",
        ACTIVE_END: date.format("YYYY-MM-DD") + "T23:59:59",
        CALENDAR_TYPE: "FULL",
      },
    };

    axios
      .get("/schedule/list", config)
      .then((res) => {
        const resList = res.data.SCHEDULE;
        const list = [];
        resList.forEach((schedule) => {
          list.push({
            id: schedule.SCHEDULE_ID,
            title: schedule.TITLE,
            start: schedule.START_TIME,
            end: schedule.END_TIME,
            data: schedule,
          });
        });
        setScheduleList(list);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [date]);

  useEffect(() => {
    if (init) {
      getRoomList();
      getScheduleList();
      setInit(false);
    }
  }, [getRoomList, getScheduleList, init]);

  useEffect(() => {
    if (isRoomSearch) {
      getRoomList();
      setIsRoomSearch(false);
    }
  }, [getRoomList, isRoomSearch]);

  useEffect(() => {
    if (isScheduleSearch) {
      getScheduleList();
      setIsScheduleSearch(false);
    }
  }, [getScheduleList, isScheduleSearch]);

  const onRefresh = () => {
    setIsScheduleSearch(true);
  };

  useEffect(() => {
    const endpointId = searchParams.get("endpointId");
    if (endpointId !== null && roomList.length > 0) {
      if (payload.id !== "") {
        //로그인 되어있음
        let tmpRoom = roomList.filter((room) => endpointId === room.id);
        setRoom(tmpRoom[0]);
        // onOpenReserve("general", tmpRoom[0]);
      } else {
        //비로그인 로그인 페이지로 이동
        console.log("로그인 페이지 이동");
        navigate(
          process.env.REACT_APP_CLIENT_URL + "?endpointId=" + endpointId
        );
      }
    }
  }, [searchParams, roomList]);

  return (
    <section className={style.room}>
      {loading && (
        <section className={style.loading}>
          <Spin />
        </section>
      )}

      <Search
        location={location}
        setLocation={(res) => {
          setLocation(res);
          setIsRoomSearch(true);
        }}
        date={date}
        setDate={(res) => {
          setDate(res);
          setIsScheduleSearch(true);
        }}
      />

      {!loading && (
        <List
          roomList={roomList}
          scheduleList={scheduleList}
          date={date}
          onRefresh={onRefresh}
          selectRoom={room}
        />
      )}
    </section>
  );
}

export default Room;
